import chart_demo from '../../images/chart_demo.png';
import chart_active from '../../images/chart_active1.png';
import chart_backtest from '../../images/chart_backtest.png';
import chart_history from '../../images/chart_history.png';
import { toNumber, formatPercent } from '../../helpers/toNumber';


const StrategyCard = ({ strategy, logoUrl, onClick }) => {
  const strategyType = strategy.strategy_type || '';
  const cardClass = `card card--${strategyType.toLowerCase()}`;
  const chartImage =
    strategyType === 'DEMO'
      ? chart_demo
      : strategyType === 'BACKTESTS'
      ? chart_backtest
      : strategyType === 'HISTORY'
      ? chart_history
      : chart_active;
      
    return (
    <div className={cardClass}>
      <div className="header">
        {logoUrl && <img src={logoUrl} alt="logo" className="icon" />}
        <span className="pair">{strategy.symbol}</span>
      </div>

      <div className="paramRow">
        <div className="section">
          <div className="label">PARAMETERS:</div>
          <div className="item"><strong>Deposit:</strong> {strategy.deposit}</div>
          <div className="item"><strong>Invested:</strong> {strategy.usd_in_trade}</div>
          <div className="item"><strong>Current Level:</strong> {strategy.current_level}</div>
          <div className="item"><strong>Start date:</strong> {strategy.start_date}</div>
        </div>
        <img src={chartImage} alt="chart" className="chartImage" />
      </div>

      <div className="section performanceRow">
        <div className="item">
          <strong>Withdrawable Profit: </strong>
          {toNumber(strategy.annual_roi) >= 0 ? (
          <span className="profitValue">{strategy.withdrawable_profit ?? '0.00'}</span>
        ) : (
          <span className="lostValue">{strategy.withdrawable_profit ?? '0.00'}</span>
        )}
        </div>
        {toNumber(strategy.annual_roi) >= 0 ? (
          <div className="greenValue">
            ▲{strategy.annual_roi}
          </div>
        ) : (
          <div className="redValue">
            ▼{strategy.annual_roi}
          </div>
        )}

      </div>

      {strategy.updatedAt && (
        <div className="lastUpdated">
          🔄 Updated at: {new Date(strategy.updatedAt).toLocaleString()}
        </div>
      )}

      <button className="button" onClick={onClick}>
        STRATEGY <span className="pro">MULTILEVEL</span>
      </button>
    </div>
  );
};

export default StrategyCard;
